import { Component, Input, Output, EventEmitter } from '@angular/core';
import { selectedButtonStyles, normalButtonStyles } from '@kite_aerolab/shared/components'
@Component({
  selector: 'kite-pagination-button',
  template: `<button 
  [ngClass]="activePage === number ? selectedButtonStyles : normalButtonStyles"
  size="sm" 
  (click)="handleOnClick()"
>
  {{number}}
</button>`
})
export class PaginationButtonComponent {
  /**
   * PageCount
   */
  @Input() number: number;

  /**
  * ActivePage
  */
  @Input() activePage: number;

  @Output()
  onClick = new EventEmitter();

  handleOnClick() {
    this.onClick.emit(this.number);
  }

  public get selectedButtonStyles(): string[] {
    return [
      selectedButtonStyles({
      }).className,
    ];
  }

  public get normalButtonStyles(): string[] {
    return [
      normalButtonStyles({
      }).className,
    ];
  }
}
